import { call, put, select, takeLatest } from 'redux-saga/effects'
import i18n from '../../../../i18n'
import { getAuthenticationJwtSelector } from '../../../login/selectors/getAuthenticationJwt.selector'
import { QaAddendumService } from '../services/qaAddendum.service'
import { ZollAPIService } from '../../../../services/zollApi.service'
import { QaAddendumConstants } from '../store/qaAddendum.constants'
import { fetchChartSummary, setFlagDetail } from '../store/qaAddendum.actions'
import { IQaFlagDetailResponse } from '../store/qaAddendum.types'
import { getSelectedFlagIdSelector } from '../selectors'
import { handleApiError } from '../../../../components/apiErrorHandler/store/apiErrorHandler.actions'
import Logger from '../../../../services/logger.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

function* getQaFlagDetail() {
  const flagId: string | null = yield select(getSelectedFlagIdSelector)
  if (!flagId) return

  const authenticationJwt: string = yield select(getAuthenticationJwtSelector)
  const qaAddendumService = new QaAddendumService(authenticationJwt)

  try {
    const response: IQaFlagDetailResponse = yield call([qaAddendumService, qaAddendumService.fetchQaFlagDetail], flagId)

    if (response.status === 200) {
      yield put(setFlagDetail(response.data ?? null))
      yield put(fetchChartSummary(flagId))
      Logger.info(`QaAddendum: getQaFlagDetail success, flagId: ${flagId}`)
    } else {
      yield put(setFlagDetail(null))
      response.failure = true
      if (response.messages?.length) {
        const index = response.messages.findIndex((x) => x.status === response.status)
        response.responseMessage = response.messages[index]?.message
      } else {
        response.responseMessage = i18n.t('qaFlags.qaAddendum.flagResolution.loadDetailError')
      }
      yield put(handleApiError(response))
    }
  } catch (e: any) {
    const cause = e.message ? e.message : 'unknown'
    yield put(setFlagDetail(null))
    yield put(
      handleApiError(
        ZollAPIService.createToastLogErrorResponse(
          i18n.t('qaFlags.qaAddendum.flagResolution.loadDetailFailed', { cause })
        )
      )
    )
  }
}

export function* getQaFlagDetailSaga() {
  yield takeLatest([QaAddendumConstants.FETCH_QA_FLAG_DETAIL], performWithMutexHOG, getQaFlagDetail)
}
